/* eslint-disable no-console */
import {message} from 'antd';
import {NoticeType} from 'antd/es/message/interface';

const showMessage = (
  item?: {status: NoticeType; message: string},
  sec?: number,
  isSWW: boolean = false
): any => {
  if (item?.message && !isSWW) {
    const messageType = (item?.status as NoticeType) ?? 'info';

    return message[messageType](item?.message ?? '', sec ?? 4);
  } else {
    return message.error('Oops! Something went wrong', sec ?? 4);
  }
};

export default showMessage;
